import { useSearchParams } from "react-router-dom";
import { Mail, Phone, Linkedin } from "lucide-react";
import { useLang } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LeadForm } from "@/components/LeadForm";
import { Reveal, MaskedLine } from "@/components/Motion";

const ContactPage = () => {
  const { t } = useLang();
  const [params] = useSearchParams();
  const unit = params.get("unit") || "general";
  const service = params.get("service") || "";

  return (
    <div data-testid="contact-page" className="bg-[#FAFAFD] text-[#353535] min-h-screen">
      <Navbar />

      <section className="px-5 sm:px-8 pt-36 pb-24 sm:pt-44">
        <div className="mx-auto max-w-[1400px] grid gap-14 lg:grid-cols-2">
          <div>
            <div className="font-jbmono text-[11px] uppercase tracking-[0.3em] text-[#4361ee] mb-6">
              <MaskedLine delay={0.1}>{t.contact.kicker}</MaskedLine>
            </div>
            <h1 className="font-playfair font-medium leading-[1.05] text-[11vw] sm:text-[6vw] lg:text-[4.6vw] tracking-tight">
              <MaskedLine delay={0.25}>{t.contact.title}</MaskedLine>
            </h1>
            <Reveal delay={0.4}>
              <p className="mt-7 max-w-md text-base text-[#999999] font-jakarta leading-relaxed">{t.contact.sub}</p>
            </Reveal>
            <Reveal delay={0.55}>
              <div className="mt-12 font-jbmono text-[11px] uppercase tracking-[0.3em] text-[#999999] mb-5">{t.contact.direct}</div>
              <div className="flex flex-col gap-4 font-jakarta">
                <a data-testid="contact-email-link" href="mailto:a4p@analytics4people.com" className="flex items-center gap-3 text-lg hover:text-[#4361ee] transition-colors">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#4361ee]/8"><Mail size={16} /></span>
                  a4p@analytics4people.com
                </a>
                <a data-testid="contact-phone-link" href="tel:+34687447999" className="flex items-center gap-3 text-lg hover:text-[#4361ee] transition-colors">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#4361ee]/8"><Phone size={16} /></span>
                  +34 687 447 999
                </a>
                <a data-testid="contact-linkedin-link" href="https://www.linkedin.com/company/analytics4people" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-lg hover:text-[#4361ee] transition-colors">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#4361ee]/8"><Linkedin size={16} /></span>
                  LinkedIn
                </a>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="rounded-3xl border border-black/8 bg-white p-7 sm:p-10 shadow-[0_30px_80px_rgba(30,30,56,0.07)]">
            <LeadForm key={`${unit}-${service}`} defaultUnit={unit} service={service} showUnitSelect accent="#4361ee" />
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
